module.exports = {
    mode: 'production',
    getE() {
        let vals = [3, 5, 13, 19, 23, 32, 39, 45, 55, 63, 77, 81, 84, 86, 89, 92, 97]
        return vals[Math.floor(Math.random() * vals.length)]
    },
    getS() {
        let vals = [26, 51, 74, 95]
        return vals[Math.floor(Math.random() * vals.length)]
    },
    getN() {
        let vals = [18, 39, 59, 76, 97]
        return vals[Math.floor(Math.random() * vals.length)]
    },
    getT() {
        let vals = [18, 32, 46, 61, 83, 96]
        return vals[Math.floor(Math.random() * vals.length)]
    },
    getF() {
        let vals = [19, 25, 35, 51, 65, 97]
        return vals[Math.floor(Math.random() * vals.length)]
    },
    getJ() {
        let vals = [13, 27, 45, 67, 94]
        return vals[Math.floor(Math.random() * vals.length)]
    },
    getResult(e, s, n, t, f, j) {
        let result = e > 51 ? 'E' : 'I'
        result += s > n ? 'S' : 'N'
        result += t > f ? 'T' : 'F'
        result += j > 51 ? 'J' : 'P'

        return result
    }
}